import { usePageDialogStore } from '@/stores/usePageDialogStore';

export function useJobEditDialog() {
  const pageDialogStore = usePageDialogStore();

  function open(
    jobId: number,
    jobDate: string,
    jobs: readonly { jobId: number; jobDate: string }[],
    onDataChanged?: () => Promise<void>,
  ): void {
    pageDialogStore.open('jobEdit', {
      jobId,
      jobDate,
      jobs: [...jobs],
      onDataChanged,
    });
  }

  return {
    open,
  };
}
